import { gemoji } from 'gemoji';

export type EmojiMatch = {
  emoji: string;
  /** The shortcode name that matched, or the primary name for a tag match */
  name: string;
};

const NO_MATCH = Number.POSITIVE_INFINITY;

const rankName = (name: string, query: string): number => {
  if (name === query) return 0;
  if (name.startsWith(query)) return 1;
  if (name.includes(`_${query}`)) return 2;
  if (name.includes(query)) return 4;
  return NO_MATCH;
};

export const searchEmoji = (query: string, limit: number): EmojiMatch[] => {
  const normalizedQuery = query.toLowerCase();
  if (!normalizedQuery) return [];

  const rankedMatches: Array<EmojiMatch & { rank: number }> = [];
  for (const { emoji, names, tags } of gemoji) {
    let rank = tags.some((tag) => tag.startsWith(normalizedQuery))
      ? 3
      : NO_MATCH;
    let name = names[0];
    for (const candidateName of names) {
      const candidateRank = rankName(candidateName, normalizedQuery);
      if (candidateRank >= rank) continue;
      rank = candidateRank;
      name = candidateName;
    }
    if (rank !== NO_MATCH) rankedMatches.push({ emoji, name, rank });
  }

  // The sort is stable, so equal ranks keep gemoji's order, which puts faces first
  return rankedMatches
    .sort((first, second) => first.rank - second.rank)
    .slice(0, limit)
    .map(({ emoji, name }) => ({ emoji, name }));
};
